import { ClassNamesProps } from '~/models/ClassNamesProps';

/** Wrapper grid for a SummaryItem */
export const SummaryGrid = ({ children, classnames }: ClassNamesProps) => {
    return (
        <div
            className={`grid grid-cols-1 divide-y border-neutrals-200 divide-neutrals-200 -mx-4 sm:-mx-6 ${classnames}`}
        >
            {children}
        </div>
    );
};
